import { Box } from '@chakra-ui/react'
import React from 'react'

export function Layout({ header, searchBar, ...props }: any) {
  const { children } = props;
  return (
    <div>
      <Box zIndex={100} paddingTop="10px" position="sticky" top={0} background="white" paddingBottom="15px">
        <Box height="50px" marginInline="16px">
          {header}
        </Box>
        <Box height="100%" marginInline="20px">
          {searchBar}
        </Box>
      </Box>
      <Box height="100%" marginInline="20px">
        {children}
      </Box>
    </div>
  )
}